import React, { useEffect, useRef, useState } from "react";
import "./FilterSelectComponent.scss";

function FilterSelect({ label, name, items, selectedValue, onChanged }) {
    const [showDropDown, setShowDropDown] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        document.addEventListener("mousedown", handleDocumentClick, false);
        return () => document.removeEventListener("mousedown", handleDocumentClick, false);
        function handleDocumentClick(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setShowDropDown(false);
            }
        }
    }, []);

    const selectedItem = items.find((item) => item.value === selectedValue);
    const selectedLabel = selectedItem ? selectedItem.text : "";

    return (
        <div className="filter-container" ref={containerRef}>
            <div className="filter-select" onClick={() => setShowDropDown((prev) => !prev)}>
                <span>
                    {label}: {selectedLabel}
                </span>
            </div>

            {items.length > 0 && showDropDown ? (
                <div className="filter-items-container">
                    <div className="filter-items">
                        <ul>
                            {items.map((item) => (
                                <li
                                    key={item.text}
                                    className={item.value === selectedValue ? "filter-selected" : ""}
                                    onClick={() => selectItem(item.value)}
                                >
                                    {item.text}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            ) : null}
        </div>
    );

    function selectItem(value) {
        onChanged(name, value);
        setShowDropDown(false);
    }
}

export default FilterSelect;
